/**
 * Copyright (c) 2018-2021 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author David Sehnal <david.sehnal@gmail.com>
 */
import { __assign } from "tslib";
import { ParamDefinition as PD } from '../../../mol-util/param-definition';
import { UnitsMeshParams, UnitsSpheresParams, UnitsSpheresVisual, UnitsMeshVisual } from '../units-visual';
import { createElementSphereImpostor, ElementIterator, getElementLoci, eachElement, createElementSphereMesh } from './util/element';
import { BaseGeometry } from '../../../mol-geo/geometry/base';
export var ElementSphereParams = __assign(__assign(__assign({}, UnitsMeshParams), UnitsSpheresParams), {
  sizeFactor: PD.Numeric(1, {
    min: 0,
    max: 10,
    step: 0.1
  }),
  detail: PD.Numeric(0, {
    min: 0,
    max: 3,
    step: 1
  }, BaseGeometry.CustomQualityParamInfo),
  ignoreHydrogens: PD.Boolean(false),
  traceOnly: PD.Boolean(false),
  tryUseImpostor: PD.Boolean(true)
});
export function ElementSphereVisual(materialId, structure, props, webgl) {
  return props.tryUseImpostor && webgl && webgl.extensions.fragDepth ? ElementSphereImpostorVisual(materialId) : ElementSphereMeshVisual(materialId);
}
export function ElementSphereImpostorVisual(materialId) {
  return UnitsSpheresVisual({
    defaultProps: PD.getDefaultValues(ElementSphereParams),
    createGeometry: createElementSphereImpostor,
    createLocationIterator: ElementIterator.fromGroup,
    getLoci: getElementLoci,
    eachLocation: eachElement,
    setUpdateState: function (state, newProps, currentProps) {
      state.createGeometry = newProps.ignoreHydrogens !== currentProps.ignoreHydrogens || newProps.traceOnly !== currentProps.traceOnly;
    },
    mustRecreate: function (structureGroup, props, webgl) {
      return !props.tryUseImpostor || !webgl;
    }
  }, materialId);
}
export function ElementSphereMeshVisual(materialId) {
  return UnitsMeshVisual({
    defaultProps: PD.getDefaultValues(ElementSphereParams),
    createGeometry: createElementSphereMesh,
    createLocationIterator: ElementIterator.fromGroup,
    getLoci: getElementLoci,
    eachLocation: eachElement,
    setUpdateState: function (state, newProps, currentProps) {
      state.createGeometry = newProps.sizeFactor !== currentProps.sizeFactor || newProps.detail !== currentProps.detail || newProps.ignoreHydrogens !== currentProps.ignoreHydrogens || newProps.traceOnly !== currentProps.traceOnly;
    },
    mustRecreate: function (structureGroup, props, webgl) {
      return props.tryUseImpostor && !!webgl;
    }
  }, materialId);
}